import { hasErrors } from '../validators';

export interface CardProps {
  isCardCompleted: boolean;
  error: string;
  highlight: boolean;
}

export const cardInitialState = {
  isCardCompleted: true,
  error: '',
  highlight: false
};

const cardModel = {
  state: { cardStatus: cardInitialState },
  effects: {
    formErrorWatcher: [
      function*({ take, put }) {
        while (true) {
          const {
            payload: { cards }
          } = yield take('form/set/error');
          if (hasErrors(cards)) {
            yield put({ type: 'children/card/highlight', payload: true });
          }
        }
      },
      { type: 'watcher' }
    ]
  }
};

export default cardModel;
